<template>
  <div class="database">
    <div class="header">
      <el-card class="box-card">
        <el-row align="middle" type="flex">
          <el-col :span="14">
            <span>网班系统管理员后台</span>
            <el-button round class="add" @click="addQues" size="small">
              <i class="el-icon-circle-plus"></i>添加试题
            </el-button>
          </el-col>
          <el-col :span="10">
            <div class="search-rg">
              <el-input
                class="search"
                size="small"
                v-model="search"
                placeholder="搜索试题名称"
              ></el-input>
              <el-button type="warning" size="small" @click="handleSeach"
                >搜索</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="题干" min-width="270">
        <template slot-scope="scope">
          <span v-html="scope.row.name"></span>
        </template>
      </el-table-column>
      <el-table-column label="题型" min-width="90" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">单选题</span>
          <span v-if="scope.row.type == 2">多选题</span>
          <span v-if="scope.row.type == 3">判断题</span>
          <span v-if="scope.row.type == 4">填空题</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="keyword"
        label="关键字"
        min-width="180"
        align="center"
      ></el-table-column>

      <!-- <el-table-column
      prop="chapter_id"
      label="所属章节"
      width="180">
      </el-table-column>-->
      <el-table-column
        prop="difficulty"
        label="难易度"
        min-width="90"
        align="center"
      ></el-table-column>
      <el-table-column label="发布人" align="center" min-width="90">
        <template slot-scope="scope">{{ scope.row.user_name }}</template>
      </el-table-column>
      <el-table-column label="状态" align="center" min-width="90">
        <template slot-scope="scope">{{
          scope.row.status == 0 ? "正常" : "屏蔽"
        }}</template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="90">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button type="text" size="small" @click="handleShield(scope.row)"
            >屏蔽</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="total">
      <div class="pages-item">
        <p class="pages-text">
          每页显示{{ pageSize }} 条记录，共 {{ total }}条记录
        </p>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="pageSize"
        prev-text="上一页"
        next-text="下一页"
        layout="prev, pager, next"
        :total="total"
        class="pages-item"
      ></el-pagination>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
    >
      <addQuestion
        :editType="editType"
        @saveQuestion="saveQuestion"
        :ques="question"
        :database="database"
      ></addQuestion>
    </el-dialog>
  </div>
</template>

<script>
import AddQuestion from "../components/addQuestion.vue";
export default {
  components: { AddQuestion },
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      search: "",
      question: {},
      total: "",
      pageSize: 20,
      page: 1,
      title: "新增试题",
      database: true,
      editType: null,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let _this = this;
      _this.$http
        .post(process.env.VUE_APP_URL + "banks", {
          search: _this.search,
          page: _this.page,
        })
        .then(function(data) {
          if (data.data.code == 200) {
            _this.total = data.data.count;
            _this.tableData = data.data.data;
          } else {
            _this.$message.error(data.data.msg);
          }
        })
        .catch(function(error) {
          _this.$message.error("网络错误,请刷新界面重试");
          return;
        });
    },
    addQues() {
      this.question = null;
      this.dialogVisible = true;
      this.editType = null;
    },
    handleSeach() {
      this.page = 1;
      this.init();
    },
    handleEdit(row) {
      this.title = "编辑试题";
      this.editType = row.type;
      let q = JSON.parse(JSON.stringify(row));
      if (this.editType !== 2) {
        q.options.forEach((item, index) => {
          if (item.is_right) {
            q.is_right = index;
          }
        });
        this.question = q;
      } else {
        q.is_right = [];
        q.options.forEach((item, index) => {
          if (item.is_right) {
            q.is_right.push(Number(index));
          }
        });
        this.question = q;
      }
      this.dialogVisible = true;
    },
    handleCurrentChange(current) {
      let _this = this;
      _this.page = current;
      _this.init();
    },
    handleShield(row) {
      let _this = this;
      _this.$http
        .post(process.env.VUE_APP_URL + "questionShield", { id: row.id })
        .then(function(data) {
          if (data.data.code == 200) {
            _this.$message.success("已屏蔽");
            row.status = 1;
          } else {
            _this.$message.error(data.data.msg);
          }
        })
        .catch(function(error) {
          _this.$message.error("网络错误,请刷新界面重试");
          return;
        });
    },
    saveQuestion(data) {
      console.log(data);
      let _this = this,
        params = JSON.parse(JSON.stringify(data));
      params.options = JSON.stringify(params.options);
      if (this.question) {
        _this.$http
          .post(process.env.VUE_APP_URL + "bankUpdateQusetion", params)
          .then(function(data) {
            if (data.data.code == 200) {
              _this.$message.success("修改成功！");
              _this.dialogVisible = false;
              _this.init();
            } else {
              _this.$message.error(data.data.msg);
            }
          })
          .catch(function(error) {
            _this.$message.error("网络错误,请刷新界面重试");
            return;
          });
      } else {
        _this.$http
          .post(process.env.VUE_APP_URL + "bankInsertQusetion", params)
          .then(function(data) {
            if (data.data.code == 200) {
              _this.$message.success("新增试题成功！");
            } else {
              _this.$message.error(data.data.msg);
            }
          })
          .catch(function(error) {
            _this.$message.error("网络错误,请刷新界面重试");
            return;
          });
      }
    },
  },
};
</script>
<style lang="less" scope>
.search {
  width: 300px;
  margin-right: 10px;
}
.pages {
  padding: 10px;
  background-color: #f6f9fc;
  text-align: right;
  font-size: 14px;
  color: #606266;
  .pages-item {
    display: inline-block;
    vertical-align: middle;
  }
  .el-pagination {
    margin-left: 20px;
  }
}
img {
  width: 100px;
}
</style>
